/* Peachy Earth homepage sections — reveals + quick add */
(function () {
  'use strict';
  if (window.__peachyHomeInit) return;
  window.__peachyHomeInit = true;

  function init() {
    /* Reveal on scroll */
    var reveals = document.querySelectorAll('.pe-reveal');
    if ('IntersectionObserver' in window && reveals.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            var el = e.target;
            var delay = parseInt(el.getAttribute('data-delay') || '0', 10);
            setTimeout(function () { el.classList.add('is-in'); }, delay);
            io.unobserve(el);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      reveals.forEach(function (el) { io.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    }

    /* Quick add (single-variant products) */
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest('.pe-quick-add');
      if (!btn || btn.disabled) return;
      ev.preventDefault();
      var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
      if (!variantId) return;
      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = '…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          /* Shapes theme: refresh badge + drawer via documented theme events */
          document.dispatchEvent(new CustomEvent('theme:update:cart', { bubbles: true }));
          try {
            if (window.Alpine && window.Alpine.store) {
              var cc = window.Alpine.store('cart_count');
              if (cc) cc.count = cart.item_count;
              var modals = window.Alpine.store('modals');
              if (modals && typeof modals.open === 'function') modals.open('cart');
            }
          } catch (e) { /* non-Alpine theme — ignore */ }
          /* generic events for other listeners/apps */
          document.dispatchEvent(new CustomEvent('cart:add', { detail: { cart: cart, id: variantId, quantity: 1 }, bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart: cart }, bubbles: true }));
          btn.textContent = 'Added ✓';
          btn.classList.add('is-added');
          setTimeout(function () {
            btn.textContent = original;
            btn.classList.remove('is-added');
            btn.disabled = false;
          }, 2200);
        })
        .catch(function () {
          btn.textContent = original;
          btn.disabled = false;
          window.location.href = '/cart/add?id=' + variantId + '&quantity=1&return_to=/cart';
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
